import { authHeaders, config } from '../helpers';

import axios from 'axios';

export default function submitData(url, data = {}, type, dispatch, includeAuthHeader = true,
    additionalActionData = {}, method = 'POST', isJsonData = true, delay = 0, onSuccess, onError) {
    dispatch({
        type: type.pending,
        ...additionalActionData
    });
    const requestOptions = {
        method,
        headers: isJsonData ? { 'Content-Type': 'application/json' } : {},
        data: JSON.stringify(data),
        url: `${config.apiUrl}${url}`,
    };

    if (includeAuthHeader) {
        requestOptions.headers = { ...requestOptions.headers, ...authHeaders() };
    }

    axios.request(requestOptions)
        .then(response => {
            setTimeout(() => {
                dispatch({
                    type: type.fulfilled,
                    payload: response.data,
                    ...additionalActionData
                });
                if (onSuccess) {
                    onSuccess(response.data);
                }
            }, delay);

        }).catch(error => {

            var data = {...error.response};

            if( !data){
                data = {data: error};
            }
            else if(!error.response){
                data.data = error;
            }
            else if( error.response.status === 401){
                data.data = "Unauthorized";
            }
            else if( error.response.status === 404){
                data.data = "Not Found";
            }
            else if(!error.response.data){
                data.data = 'There was an error processing your request';
            }

            setTimeout(() => {
                dispatch({
                    type: type.rejected,
                    payload: data,
                    ...additionalActionData
                });
                if (onError) {
                    onError(data);
                }
            }, delay);
        });
}


// WEBPACK FOOTER //
// ./src/common/postData.js